import AbstractAnimation from "./abstract-animation";
import {Sine, TweenLite} from "gsap";

export default class HideAndShowByFade extends AbstractAnimation
{
    create(): any {
        let duration = undefined === this.params.duration ? 0.2 : this.params.duration;
        let $show = undefined === this.params.show ? null : this.params.show;
        this.$element.css({opacity: 1});
        if ($show) {
            $show.css({opacity: 0});
            $show.removeAttr('hidden');
            return this
                .timeline
                .to(this.$element, duration, {opacity: 0, ease: Sine.easeInOut}, 0)
                .to($show, duration, {opacity: 1, ease: Sine.easeOut}, 0);
        } else {
            return this
                .timeline
                .to(this.$element, duration, {opacity: 0, ease: Sine.easeInOut});
        }
    }
}